import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-delete-confirm-modal',
  templateUrl: './delete-confirm-modal.component.html',
  styleUrls: ['./delete-confirm-modal.component.scss']
})
export class DeleteConfirmModalComponent implements OnInit {

  @Input() title: any

  public event: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
  }

  confirm() {
    this.bsModalRef.hide()
    this.triggerEvent(true)
  }

  decline() {
    this.triggerEvent(false)
    this.bsModalRef.hide()
  }
  
  triggerEvent(item) {
    this.event.emit({ data: item, res: 200 });
  }

}
